<mat-select
    #select
    [attr.aria-labelledby]="_formField.getLabelId()"
    (focusin)="onFocusIn($event)"
    (focusout)="onFocusOut($event)"
    [formControl]="form"
    [compareWith]="CompareOptions"
    (selectionChange)="onSelectionChange($event.value)"
    [panelClass]="'mat-select-panel-h400 ' + panelClass"
    (opened)="opened.emit()"
>
    <mat-select-trigger *ngIf="triggerTemplate">
        <ng-container *ngTemplateOutlet="triggerTemplate"></ng-container>
    </mat-select-trigger>
    <ng-container *ngIf="selectedOption$ | async as option; else optionList">
        <mat-option [value]="option">
            <ng-container *ngTemplateOutlet="OptionTemplate ? OptionTemplate : defaultTemplate; context: { $implicit: option, isSelected: true }"></ng-container>
        </mat-option>
    </ng-container>
    <ng-template #optionList>
        <mat-option class="select-search-option-with-suffix">
            <ngx-mat-select-search #search [hideClearSearchButton]="true" [clearSearchInput]="false" [formControl]="searchForm" [placeholderLabel]="SearchPlaceholderLabel" [noEntriesFoundLabel]="NoEntriesFoundLabel">
                <!--            <fa-icon ngxMatSelectSearchClear icon="times"></fa-icon>-->
                <div class="mat-select-search-custom-header-content" style="display: flex">
                    <!--                <app-loading *ngIf="isSearching$ | async" [Size]="10"></app-loading>-->
                    <button mat-icon-button *ngIf="searchForm.value"><fa-icon (click)="searchForm.reset()" icon="times"></fa-icon></button>
                    <!--                <button mat-icon-button><fa-icon icon="filter"></fa-icon></button>-->
                    <ng-content select="[search-bar-suffix]"></ng-content>
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading" class="progress-bar"></mat-progress-bar>
                </div>
            </ngx-mat-select-search>
        </mat-option>
        <mat-option class="shadow-option" *ngIf="shadowOption$ | async as option" [value]="option">
            <ng-container *ngTemplateOutlet="OptionTemplate ? OptionTemplate : defaultTemplate; context: { $implicit: option }"></ng-container>
        </mat-option>
        <ng-container *ngFor="let option of filteredOptions$ | async">
            <mat-optgroup *ngIf="option.childOptions" label="{{ option.optionLabel }}">
                <mat-option *ngFor="let childOption of option.childOptions" [value]="childOption">
                    <ng-container *ngTemplateOutlet="OptionTemplate ? OptionTemplate : defaultTemplate; context: { $implicit: childOption }"></ng-container>
                </mat-option>
            </mat-optgroup>
            <mat-option *ngIf="!option.childOptions" [value]="option">
                <ng-container *ngTemplateOutlet="OptionTemplate ? OptionTemplate : defaultTemplate; context: { $implicit: option }"></ng-container>
            </mat-option>
        </ng-container>
        <div style="position: sticky; bottom: 0">
            <ng-content select="[option-list-footer]"></ng-content>
        </div>
    </ng-template>
</mat-select>

<ng-template #defaultTemplate let-option let-isSelected="isSelected">
    <div class="option-content" [class.selected]="isSelected">
        <span class="option-label">
            {{ option.optionLabel }}
        </span>

        <fa-icon
            *ngIf="option.infoTooltip"
            icon="question-circle"
            [matTooltip]="option.infoTooltip">
        </fa-icon>

        <button
            mat-icon-button
            *ngIf="isSelected"
            (click)="$event.preventDefault(); form.reset(); onSelectionChange(null)">
            <fa-icon icon="times"></fa-icon>
        </button>
    </div>
</ng-template>
